import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RobotRulesService, EditMode, RateEventType } from '../../robot-rules.service';
import _ from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@root/shared/service/translate.service';

@Component({
  selector: 'host-reply-guest-rules',
  templateUrl: './reply-guest.component.html',
  styleUrls: ['./reply-guest.component.scss'],
})
export class ReplyGuestComponent implements OnInit {
  @ViewChild('textarea', { static: true }) textarea;
  readonly EventType: typeof RateEventType = RateEventType;
  private readonly EventMap: Record<RateEventType, Array<any>> = {
    [RateEventType.Checkout]: [
      { label: this.t.syncGet('robot.rule.check_event.after_checkout'), value: 'after_checkout', type: 1 },
    ],
  };
  private readonly defaultScopeChannels = [-1];
  private readonly defaultScopeAccounts = [-1];
  private readonly defaultScopeHouses = [-1];
  @Input() editMode: EditMode = EditMode.Create;
  // @Input() event: RateEventType = RateEventType.Checkout;
  @Input() id;
  // @Input() subevent = 'after_checkout'; // 暂时只有一个，且不可改
  @Input() listOfChannelOption = [];
  // @Input() listOfHouseOption = [];
  @Input() listOfDynContentOption = [];
  // listOfStarOption = [
  //   { label: '1星及以下', value: 'less_2_star', checked: false },
  //   { label: '2星', value: '2_star', checked: false },
  //   { label: '3星', value: '3_star', checked: false },
  //   { label: '4星', value: '4_star', checked: false },
  //   { label: '5星', value: '5_star', checked: false },
  // ];
  listOfStarOption = ['less_2_star', '2_star', '3_star', '4_star', '5_star'].map((value) => ({
    label: this.t.syncGet(`automation.rate_rule.condition.opt.${value}`),
    value,
    checked: false,
  }));
  listOfChannelAccountOption = [];
  // selectHouseType: "none" | "house" | "group" = "none";
  scopeChannels = null;
  scopeAccounts = null;
  scopeHouses = {
    type: 'none',
    value: this.defaultScopeHouses,
  };
  actionNodeMinute = 13 * 60; // 默认13点
  actionTextType = 0; // 文本类型 0-文本 1-快捷回复
  actionTextContent = '';
  actionQuickMsgId = null; // 快捷消息id，textType = 1 时有效
  // initialChannels = [];
  // initialAccounts = [];
  // initialHouses = [];
  // initialGroupOrType = null;
  dynContent;
  private selectHouseSubType: 'group' | 'type';
  /** 理论可以不需要这个getter，因为只有一个选项，且不可更改，为了和其他页面逻辑统一，采用统一的处理方式 */
  // get subeventOptions () {
  //   return this.EventMap[this.event]
  // }
  constructor(
    private http: RobotRulesService,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private modalRef: NzModalRef,
    private t: TranslateService
  ) {}

  ngOnInit() {
    if (this.editMode === EditMode.Update || this.editMode === EditMode.Copy) {
      this.fetchRateRuleDetail();
    } else {
      this.initSelectOptions();
      // this.fetchChannelAccounts();
    }
  }

  private initSelectOptions() {
    this.fetchChannelAccounts();
  }

  private fetchChannelAccounts() {
    const params = {
      from: 'comment',
    };

    if (this.scopeChannels) {
      const channels = this.scopeChannels.filter((c) => c.thirdparty_type !== -1).map((c) => c.thirdparty_type);
      Object.assign(params, { thirdparty_types: JSON.stringify(channels) });
    }

    this.http.fetchChannelAccounts(params).subscribe((res) => {
      console.log('res: ', res);
      const list = _.get(res, 'data.list');
      this.listOfChannelAccountOption = list.map((account) => ({
        ...account,
        label: account.username,
        value: account.id,
      }));
    });
  }
  fetchRateRuleDetail() {
    this.http.fetchRateReplyRuleDetail({ id: this.id }).subscribe((res) => {
      const record = _.get(res, 'data.record') || {};
      const { id, action, event, scope } = record;
      this.id = id;
      this.convertFromEventParams(event);
      this.convertFromActionParams(action);
      this.convertFromScopeParams(scope);

      // this.fetchChannelAccounts();
      this.initSelectOptions();
    });
  }
  requestSaveRateRobotRules() {
    const status = 1;
    const event = this.convertToEventParams();
    const action = this.convertToActionParams();
    const scope = this.convertToScopeParams();

    const params = { status, event, action, scope };

    if (this.editMode === EditMode.Update) {
      /** 新建和复制都不传id */
      _.assign(params, { id: this.id });
    }

    this.http.updateRateReplyRobotRules(params).subscribe((res) => {
      console.log('res: ', res);
      if (res.error_code === 0) {
        this.messageService.success(this.t.syncGet('word.success'));

        this.close();
      }
    });
  }

  onSave() {
    this.requestSaveRateRobotRules();
  }

  onCancel() {
    this.close();
  }

  onSelectHouseTypeChange(type) {
    console.log('type: ', type);
    // if (type === "none") {
    //   this.scopeHouses = [{ id: -1, house_title: "" }];
    // }
  }

  onSelectHousesByHouse(ids = []) {
    // console.log("by house: ", ids);
    // this.scopeHouses = ids.map((id) => ({ id, house_title: "" }));
  }

  onSelectHousesByGroup(data) {
    // const { ids, type } = data;
    // this.selectHouseSubType = type;
    // this.scopeHouses = ids.map((id) => ({ id, house_title: "" }));
    // console.log("by group: ", data);
  }

  onSelectChannels(channels = []) {
    // console.log("channels: ", channels);
    // this.scopeChannels = channels.map((channel) => ({
    //   thirdparty_type: channel,
    //   name: "",
    // }));

    this.fetchChannelAccounts();
  }

  onSelectAccounts(accounts) {
    // console.log("accounts: ", accounts);
    // this.scopeAccounts = accounts.map((account) => ({
    //   id: account,
    //   name: "",
    // }));
  }

  onSelectQuickMsgOfAction(data = { id: null, content: '' }) {
    console.log('onSelectQuickMsgOfAction', data);
    const { id, content } = data;
    this.actionQuickMsgId = id;
    this.actionTextContent = content;
  }

  onSelectDynContent(content) {
    const value = this.actionTextContent;
    const pos = this.textarea.nativeElement.selectionStart;

    this.actionTextContent = value.slice(0, pos) + `{{${content}}}` + value.slice(pos);
  }

  private convertToEventParams() {
    const subEventType = this.listOfStarOption.filter((o) => o.checked).map((o) => o.value);
    return {
      event_type: 'guest_committed_comment',
      sub_event_type: subEventType,
    };
  }

  private convertToActionParams() {
    const action = {
      action_type: this.actionQuickMsgId === null ? 0 : 1,
      text_content: this.actionTextContent,
      quick_message_id: this.actionQuickMsgId,
      node_minute: this.actionNodeMinute,
    };
    return action;
  }

  private convertToScopeParams() {
    const scope = {
      thirdparty: this.getOrDefault(this.scopeChannels, this.defaultScopeChannels),
      account: this.getOrDefault(this.scopeAccounts, this.defaultScopeAccounts),
    };

    const { type, value } = this.scopeHouses;
    const scopeHouses = this.getOrDefault(value, this.defaultScopeHouses);

    if (type === 'none') {
      Object.assign(scope, { property_any: [-1] });
    } else if (type === 'house') {
      Object.assign(scope, { house: scopeHouses });
    } else if (type === 'group') {
      Object.assign(scope, { group: scopeHouses });
    } else {
      Object.assign(scope, { room_type: scopeHouses });
    }
    return scope;
  }

  private convertFromEventParams(params) {
    const subEventType = params.sub_event_type;
    this.listOfStarOption.forEach((o) => {
      if (subEventType.indexOf(o.value) !== -1) {
        o.checked = true;
      }
    });
  }
  private convertFromActionParams(params) {
    this.actionQuickMsgId = params.quick_message_id === -1 ? null : params.quick_message_id;
    this.actionTextContent = params.text_content;
    this.actionNodeMinute = params.node_minute;
  }

  private convertFromScopeParams(params) {
    if (params.account?.[0] === -1) {
      this.scopeAccounts = null;
    } else {
      this.scopeAccounts = params.account;
    }

    if (params.thirdparty?.[0] === -1) {
      this.scopeChannels = null;
    } else {
      this.scopeChannels = params.thirdparty;
    }

    if (params.house || params.property_any) {
      if (params.house?.[0] === -1 || params.property_any?.[0] === -1) {
        this.scopeHouses = {
          type: 'none',
          value: [-1],
        };
      } else {
        this.scopeHouses = {
          type: 'house',
          value: params.house,
        };
      }

      // this.scopeHouses = params.house;

      // this.initialHouses = this.scopeHouses.map((house) => house.id);
    } else if (params.group) {
      this.scopeHouses = {
        type: 'group',
        value: params.group,
      };
      // this.selectHouseType = "group";
      // this.selectHouseSubType = params.group ? "group" : "type";

      // this.scopeHouses = params.group ? params.group : params.room_type;

      // this.initialGroupOrType = {
      //   type: this.selectHouseSubType,
      //   ids: this.scopeHouses.map((house) => house.id),
      // };
    } else if (params.room_type) {
      this.scopeHouses = {
        type: 'room_type',
        value: params.room_type,
      };
    }
  }

  private getOrDefault(value: any[], defaults) {
    if (_.isEmpty(value)) {
      return defaults;
    }
    return value;
  }

  private close() {
    this.modalRef.close();
  }
}
